import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Box, Collapse, TableCell, TableRow } from '@mui/material';

import CurrentProvisionDetails from './CurrentProvisionDetails';

import classes from '../../../commonStyles/tables.module.css';
const CurrentProvisionTableRow = ({ row, toggleDropdown, openId, isDisabled, returnState }) => {
    const [open, setOpen] = useState(null);

    const { provisionStatusDetails } = useSelector((state) => state.entities.directusService);

    useEffect(() => {
        if (openId !== row.id) setOpen(null);
    }, [openId]);

    function getProvisionStatusName(statusId) {
        return provisionStatusDetails?.find((item) => item.id === statusId)?.name || '';
    }

    const onToggleDropdown = () => {
        toggleDropdown(row.id);
        setOpen(open === row.id ? null : row.id);
    };

    return (
        <>
            <TableRow
                hover
                className={`${classes.tableRowStripes} ${classes.cherry} ${classes.canOpen}`}
                onClick={onToggleDropdown}>
                <TableCell>{row.code}</TableCell>
                <TableCell>{row.provisionName}</TableCell>
                <TableCell>{row.providerName}</TableCell>
                <TableCell>{getProvisionStatusName(row.statusId)}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        borderTop: 'none',
                        borderBottom: 'none'
                    }}
                    colSpan={5}>
                    <Collapse in={open === row.id} timeout="auto" unmountOnExit>
                        <Box>
                            <CurrentProvisionDetails
                                row={row}
                                onClose={() => setOpen(null)}
                                isDisabled={isDisabled}
                                returnState={returnState}
                            />
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

CurrentProvisionTableRow.propTypes = {
    row: PropTypes.object,
    openId: PropTypes.string,
    toggleDropdown: PropTypes.func,
    isDisabled: PropTypes.bool,
    returnState: PropTypes.object
};

export default CurrentProvisionTableRow;
